import axiosClient from './axiosService';

export const userLogin = (user) =>
    axiosClient.post('/auth/login', user);

export const registerUser = (user) =>
    axiosClient.post('/auth/signup', user);

export const userList = () =>
    axiosClient.get('/auth');

export const userCount = () =>
    axiosClient.get('/auth/count');

export const getUserByUsername = (username) =>
    axiosClient.get('/auth/byUsername', {
        params: { username }
    });

export const changeUserPassword = (userId, user) =>
    axiosClient.put(`/auth/${userId}`, user);

export const verifyAuth = () =>
    axiosClient.get('/auth/verify');

export const userLogout = () =>
    axiosClient.post('/auth/logout');